import React from 'react';
import SliderComponent, { Settings } from 'react-slick';

const Slider = (props: Settings) => {
  const LocalSlider = SliderComponent as unknown as React.ComponentType<Settings>;

  return <LocalSlider {...props} />;
};

export default Slider;
